'use strict';

import i18next from 'i18next';
import locEn from './locales/en/translations.json';
import locPt from './locales/pt/translations.json';

const i18nHandler = {
  keys: document.querySelectorAll('translate'),
  init() {
    const lang = window.location.pathname.replace(/\//g, '').replace(/marcocivil/g, '');
    const langfall = 'pt';
    const location = window.location.pathname;

    if(location.indexOf('en') === -1 && location.indexOf('pt') === -1) {
      window.location = langfall;
    }

    i18next.init({
      debug: true,
      lng: lang,
      fallbackLng: langfall,
      ns: ['translations'],
      defaultNS: 'translations',
    }, (err, t) => {
      document.documentElement.lang = i18next.language;
      for(let index = 0; index < this.keys.length; index++) {
        let this_key = this.keys[index].innerText.toLowerCase();
        this.keys[index].dataset.key = this_key;
        this.keys[index].innerText = i18next.t(this_key);
      }

      // SETTING UP MENU
      // Elements
      const tracebackLinkIgarape = document.getElementById('traceback-link-igarape');
      const btnChangeLangEn = document.querySelectorAll('.menuChangeLanguageToEn');
      const btnChangeLangPt = document.querySelectorAll('.menuChangeLanguageToPt');
      const btnDownloadPDF = document.querySelectorAll('.menuDownloadPDF');
      const btnMailto = document.querySelectorAll('.menuMailto');
      const btnShareFacebook = document.querySelectorAll('.menuFacebookShare');
      const btnShareTwitter = document.querySelectorAll('.menuTwitterShare');
      const btnShareGooglePlus = document.querySelectorAll('.menuGooglePlusShare');
      const btnShareLinkedin = document.querySelectorAll('.menuLinkedinShare');

      // Values
      let igarapeLink = '#';
      const shareUrl = window.location;
      let shareUrlTwitter = '';
      let downloadPDF = '';
      let emailSubject = '';
      let shareTitle = '';
      const twitterUser = 'igarape_org';
      let twitterText = '';
      let linkedinSummary = '';
      let linkedinSource = '';

      if(i18next.language === 'en') {
        for(let index = 0; index < btnChangeLangEn.length; index++) {
          btnChangeLangEn[index].parentNode.style.display = 'none';
        }

        igarapeLink = '';
        shareUrlTwitter = '';
        downloadPDF = '';
        emailSubject = '';
        shareTitle = '';
        twitterText = '';
        linkedinSummary = '';
        linkedinSource = '';
      } else if(i18next.language === 'pt') {
        for(let index = 0; index < btnChangeLangPt.length; index++) {
          btnChangeLangPt[index].parentNode.style.display = 'none';
        }

        igarapeLink = 'https://igarape.org.br/';
        shareUrlTwitter = '';
        downloadPDF = 'assets/downloads/mulheres-linha-de-fente.pdf';
        emailSubject = 'Mulheres no Front';
        shareTitle = 'Mulheres no Front';
        twitterText = 'Leia nossa publicação sobre presença feminina nas Formas Armadas http://bit.ly/SituaçõesExtraordinárias';
        linkedinSummary = 'As mulheres conquistaram um espaço cada vez maior nas Forças Armadas desde os anos 1980 no Brasil. Quais foram seus desafios? Saiba mais sobre presença feminina na linha de frente aqui e no mundo.';
        linkedinSource = 'Instituto Igarapé';
      }

      tracebackLinkIgarape.href = igarapeLink;

      for(let index = 0; index < btnDownloadPDF.length; index++) {
        btnDownloadPDF[index].href = btnDownloadPDF[index].dataset.base + downloadPDF;
      }

      for(let index = 0; index < btnMailto.length; index++) {
        btnMailto[index].href = `mailto:teste@igarape.org.br?subject=${emailSubject}`;
      }

      // Facebook Share
      for(let index = 0; index < btnShareFacebook.length; index++) {
        btnShareFacebook[index].href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&t=${shareTitle}`;
        btnShareFacebook[index].onclick = function() {
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
          return false;
        };
      }

      // Twitter Share
      for(let index = 0; index < btnShareTwitter.length; index++) {
        btnShareTwitter[index].href = `https://twitter.com/share?url=${shareUrlTwitter}&via=${twitterUser}&text=${twitterText}`;
        btnShareTwitter[index].onclick = function() {
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
          return false;
        };
      }

      // Google Plus Share
      for(let index = 0; index < btnShareGooglePlus.length; index++) {
        btnShareGooglePlus[index].href = `https://plus.google.com/share?url=${shareUrl}`;
        btnShareGooglePlus[index].onclick = function() {
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=560,width=450');
          return false;
        };
      }

      // LinkedIn Share
      for(let index = 0; index < btnShareLinkedin.length; index++) {
        btnShareLinkedin[index].href = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${shareTitle}&summary=${linkedinSummary}&source=${linkedinSource}`;
        btnShareLinkedin[index].onclick = function() {
          window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
          return false;
        };
      }
    });

    // set json resources manually
    i18next.addResources('en', 'translations', locEn);
    i18next.addResources('pt', 'translations', locPt);
  }
};

export default i18nHandler;
